import { IGetAllChecklistMaquinaEquipUseCase } from "../../../presentation/useCases/read/get_all_checklist_maquina_equip_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
import { ChecklistMaquinaEquipModel } from "../../../domain/models/checklist_maquina_equip";

/**
 * GetAllChecklistMaquinaEquipUseCase
 */

export class GetAllChecklistMaquinaEquipUseCase
  extends BasePaginatedUseCase<ChecklistMaquinaEquipModel>
  implements IGetAllChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async execute(
    status: number | null,
    codigo: string | null,
    revisao: string | null,
    descricao: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {

    const result = await this.repository.getAllChecklistMaquinaEquip(
      status === 1 ? true : status === 0 ? false : null,
      codigo,
      revisao,
      descricao,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}